<template>
    <div>
        <sub-menu-call-center ativo="mapasala" v-if="!recepcao && !cc && !simplificado" />
        
        <div class="card dashcard mb-0" v-if="!simplificado">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :blockano="true" :sync="true" @sync="load(false)" />
                    </div>

                    <div class="col col-12 col-md-3" v-if="$store.state.unidade.unidade_operacaos.length > 1">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Todas as Unidades..."
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            @change="refresh_unidade()"
                            v-model="filtros.unidade_operacao" />
                    </div>

                    <div class="col col-12" :class="$store.state.unidade.unidade_operacaos.length > 1 ? 'col-md-3' : 'col-md-6'">
                        <az-input 
                            placeholder="Procedimento..."
                            icon="fas fa-play"
                            type="autocomplete" 
                            service="procedimentos.index"
                            optionsMode="aql"
                            optionsName="procedimentos.index" 
                            optionsData="id_procedimento"
                            v-model="filtros.id_procedimento"
                            ref="info_procedimento" />
                    </div>

                </div>
                
                <div class="form-row mt-2">
                    <template v-if="!cc">
                        <div class="col col-12 col-md-2">
                            <az-input 
                                placeholder="Especialidades..."
                                icon="fas fa-filter" 
                                type="select" 
                                optionsMode="esp-ativas"
                                optionsName="esp-ativas"
                                :optionsReload="true"
                                v-model="filtros.especialidade" />
                        </div>
                        <div class="col col-12 col-md-4">
                            <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fas fa-user-md fa-fw"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="filtros.medico">
                                <option value>Todos os Médicos...</option>
                                <option
                                    :value="item.id_pessoa"
                                    v-for="(item, index) in lista_medicos"
                                    :key="index">
                                    {{ item.st_nome_exibicao }}
                                </option>
                            </select>
                            </div>
                        </div>
                    </template>

                    <div class="col col-12 col-md-3" v-if="!cc">
                        <az-input 
                            icon="fas fa-filter fa-fw"
                            type="select"
                            placeholder="Classificação..."
                            optionsData="id_classe_procedimento"
                            service="classe_procedimentos.index"
                            optionsMode="aql"
                            v-model="filtros.id_classe_procedimento" />
                    </div>

                    <div class="col col-12" :class="cc ? '' : 'col-md-3'">
                        <az-input
                            icon="fa fa-search fa-fw"
                            placeholder="Pesquisar..."
                            v-model="search">
                            <template v-slot:buttonposb>
                                <print-export 
                                    printid="mapa-de-sala" 
                                    id="botao-de-imprimir" 
                                    :left="true"
                                    :dados="dadosFormatados" />
                            </template>
                        </az-input>
                    </div>
                    
                </div>

                <div class="form-row mt-2" v-if="!cc">
                    <div class="col col-12 col-md-6">
                        <az-input 
                            icon="fa-solid fa-person-shelter fa-fw"
                            placeholder="Local de Atendimento..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="locals.index"
                            :optionsSync="false"
                            required 
                            optionsData="id_local"
                            v-model="filtros.id_local" />
                    </div>
                </div>

                <div class="form-row mt-2" v-if="!cc">
                    <div class="col col-12 col-md-4">
                        <az-input
                            sizing="sm"
                            type="button-group"
                            :optionsList="[
                                { id: 'D', search: 'Profs vs Sala' },
                                { id: 'C', search: 'Salas' },
                                { id: 'P', search: 'Profissionais' },
                            ]" 
                            v-model="filtros.tipo" />
                    </div>
                    <div class="col col-12 col-md-8">
                        <az-input
                            sizing="sm"
                            type="button-group"
                            :optionsList="[
                                { id: '', search: 'Todos' },
                                { id: 'G', search: 'Geral' },
                                { id: 'M', search: 'Manhã' },
                                { id: 'T', search: 'Tarde' },
                                { id: 'N', search: 'Noite' },
                            ]" 
                            v-model="filtros.turno" />
                    </div>
                    
                    
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2" v-if="!simplificado">
            <div class="indeterminate" v-if="$store.state.loading && lista_salas.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <template v-if="lista_salas.length">

            <div class="d-flex justify-content-between">
                <div>
                    <div v-if="dados.periodo.inicio">Período: {{ $util.getFormatDate(dados.periodo.inicio) }} a {{ $util.getFormatDate(dados.periodo.fim) }}</div>
                </div>
                <div class="d-flex">
                    <div v-if="filtros.tipo == 'C' && dados.periodo.semana.length > 7" class="ml-5">
                        <a href="#" class="card-link" @click.prevent="visao = 'S'">
                            <i class="fa-solid fa-calendar-week" :class="visao == 'S' ? 'text-primary' : 'text-muted'" title="Visão Semanal"></i>
                        </a>
                        <a href="#" class="card-link ml-1" @click.prevent="visao = 'M'">
                            <i class="fa-solid fa-calendar-days" :class="visao == 'M' ? 'text-primary' : 'text-muted'" title="Visão Mensal"></i>
                        </a>
                    </div>
                    <div v-if="filtros.tipo == 'C'" class="ml-5">
                        <a href="#" class="card-link" @click.prevent="visao_hora = 'T'">
                            <i class="fa-solid fa-sun" :class="visao_hora == 'T' ? 'text-primary' : 'text-muted'" title="Visão por Turno"></i>
                        </a>
                        <a href="#" class="card-link ml-1" @click.prevent="visao_hora = 'H'">
                            <i class="fa-solid fa-clock" :class="visao_hora == 'H' ? 'text-primary' : 'text-muted'" title="Visão por Turno"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div id="mapa-de-sala">

                <cabecalho-generico titulo="Mapa de Sala">
                    <div>{{ $util.getFormatDate(dados.periodo.inicio) }} a {{ $util.getFormatDate(dados.periodo.fim) }}</div>
                    <div v-if="search">Pesquisa: {{ search }}</div>
                </cabecalho-generico>

                <!-- Profissionais Analítico -->
                <table class="table table-hover bg-white cabecalho-fixo" v-if="filtros.tipo == 'P'">
                    <thead>
                        <tr>
                            <th>Profissional</th>
                            <th class="text-right">Horários</th>
                            <th class="text-right">Bloqueados</th>
                            <th class="text-right">Marcados</th>
                            <th class="text-right">Extras</th>
                            <th class="text-right">Atendidos</th>
                            <th class="text-right">Faltas</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(medico, imx) in exibir_lista_profissionais" :key="imx">
                            <td>
                                <div>
                                    <a href="#" @click.prevent="pesquisar(medico.st_nome_exibicao)" class="card-link">
                                        {{ medico.st_nome_exibicao }}
                                    </a>
                                </div>
                                <a href="#" @click.prevent="pesquisar(espec.especialidade.st_especialidade)" v-for="(espec, iex) in medico.medico_especialidade" :key="iex">
                                    <span class="badge badge-secondary mr-1">
                                        {{ espec.especialidade.st_especialidade }}
                                    </span>
                                </a>
                            </td>
                            <td class="text-right">{{ medico.disp }}</td>
                            <td class="text-right">
                                <span class="badge badge-danger mr-1" v-if="medico.perc_bloq">
                                    {{ medico.perc_bloq }}%    
                                </span>
                                {{ medico.bloq }}
                            </td>
                            <td class="text-right">
                                <span class="badge badge-primary mr-1" v-if="medico.perc_marc">
                                    {{ medico.perc_marc }}%    
                                </span>
                                <span v-if="medico.marc_qtd && medico.marc_qtd != medico.marc" title="Slots | Quantidade">
                                    {{ medico.marc }} | {{ medico.marc_qtd }}
                                </span>
                                <template v-else>
                                    {{ medico.marc }}
                                </template>
                            </td>
                            <td class="text-right">
                                {{ medico.extras }}
                            </td>
                            <td class="text-right">
                                <span class="badge badge-success mr-1" v-if="medico.perc_atend">
                                    {{ medico.perc_atend }}%    
                                </span>
                                <span v-if="medico.atend_qtd && medico.atend_qtd != medico.atend" title="Slots | Quantidade">
                                    {{ medico.atend }} | {{ medico.atend_qtd }}
                                </span>
                                <template v-else>
                                    {{ medico.atend }}
                                </template>
                            </td>
                            <td class="text-right">
                                <span class="badge badge-warning mr-1" v-if="medico.perc_faltas">
                                    {{ medico.perc_faltas }}%    
                                </span>
                                <span v-if="medico.faltas_qtd && medico.faltas != medico.faltas_qtd" title="Slots | Quantidade">
                                    {{ medico.faltas }} | {{ medico.faltas_qtd }}
                                </span>
                                <template v-else>
                                    {{ medico.faltas }}
                                </template>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Total</th>
                            <th class="text-right">{{ exibir_total_profissionais.disp }}</th>
                            <td class="text-right">
                                <span class="badge badge-danger mr-1" v-if="exibir_total_profissionais.perc_bloq">
                                    {{ exibir_total_profissionais.perc_bloq }}%    
                                </span>
                                {{ exibir_total_profissionais.bloq }}
                            </td>
                            <td class="text-right">
                                <span class="badge badge-primary mr-1" v-if="exibir_total_profissionais.perc_marc">
                                    {{ exibir_total_profissionais.perc_marc }}%    
                                </span>
                                <template v-if="exibir_total_profissionais.marc_qtd && exibir_total_profissionais.marc != exibir_total_profissionais.marc_qtd">
                                    {{ exibir_total_profissionais.marc }} | {{ exibir_total_profissionais.marc_qtd }}
                                </template>
                                <template v-else>
                                    {{ exibir_total_profissionais.marc }}
                                </template>
                            </td>
                            <td class="text-right">
                                {{ exibir_total_profissionais.extras }}
                            </td>
                            <td class="text-right">
                                <span class="badge badge-success mr-1" v-if="exibir_total_profissionais.perc_atend">
                                    {{ exibir_total_profissionais.perc_atend }}%    
                                </span>
                                <template v-if="exibir_total_profissionais.atend_qtd && exibir_total_profissionais.atend != exibir_total_profissionais.atend_qtd">
                                    {{ exibir_total_profissionais.atend }} | {{ exibir_total_profissionais.atend_qtd }}
                                </template>
                                <template v-else>
                                    {{ exibir_total_profissionais.atend }}
                                </template>
                            </td>
                            <td class="text-right">
                                <span class="badge badge-warning mr-1" v-if="exibir_total_profissionais.perc_faltas">
                                    {{ exibir_total_profissionais.perc_faltas }}%    
                                </span>
                                <template v-if="exibir_total_profissionais.faltas_qtd && exibir_total_profissionais.faltas != exibir_total_profissionais.faltas_qtd">
                                    {{ exibir_total_profissionais.faltas }} | {{ exibir_total_profissionais.faltas_qtd }}
                                </template>
                                <template v-else>
                                    {{ exibir_total_profissionais.faltas }}
                                </template>
                            </td>
                        </tr>
                    </tfoot>
                </table>

                <!-- Mapa de Sala -->
                <template v-else>

                    <!-- Mapa de Sala por Médico (Simplificado) -->

                    <template v-if="filtros.tipo == 'M'">

                        <table class="table bg-white table-hover small" :class="( lista_colunas.length > 7 ? 'table-responsive' : 'cabecalho-fixo' ) + ' table-sm'">
                            <thead>
                                <tr class="table-secondary">
                                    <th :width="lista_colunas.length > 1 ? '12.5%' : ''">
                                        <a href="#" @click.prevent="exibir_profs = !exibir_profs">
                                            <i class="fa-regular fa-square-plus fa-fw mr-2" v-if="!exibir_profs"></i>
                                            <i class="fa-regular fa-square-minus fa-fw mr-2" v-else></i>
                                        </a>
                                        Profissional
                                    </th>
                                    <th :width="lista_colunas.length > 1 ? '12.5%' : ''" class="text-nowrap" v-for="(dow, idx) in lista_colunas" :key="idx">
                                        {{ dow.label }}
                                    </th>
                                </tr>
                            </thead>

                            <tbody v-if="exibir_profs">
                                <tr v-for="(med, ilx) in dados.medicos" :key="ilx">
                                    <td>
                                        <div>{{ med.st_nome_exibicao }}</div>
                                        <div class="text-muted" v-if="med.especialidade">{{ med.especialidade.st_especialidade }}</div>
                                    </td>
                                    <td v-for="(dow, idx) in lista_colunas" :key="idx">
                                        <div v-if="1 == 0 && lista_colunas[idx].feriado" class="text-muted">
                                            {{ lista_colunas[idx].feriado.st_descricao }}
                                        </div>

                                        <!-- Ocupação dos Médicos -->
                                        <div>
                                            <!-- agendas_do_dia(local.agendas, dow.dia) -->
                                            <div v-for="(agenda, iax) in agendas_tabela(null, dow, med)" :key="ilx + '-' + iax">
                                                <span class="text-nowrap" :class="( agenda.bloqueio ? 'text-muted' : '' ) + ( lista_colunas.length == 1 ? '' : 'div' )">
                                                    <a href="#" @click.prevent="selecionar_medico_dia(med, dow)" class="card-link">
                                                        {{ agenda.search }}
                                                    </a>
                                                    <span class="badge" v-if="!cc && lista_colunas.length > 1"
                                                        :class="agenda.marcacoes >= agenda.disponibilidade ? 'badge-success' : ( agenda.marcacoes ? 'badge-primary' : 'badge-secondary' )">
                                                        {{ agenda.marcacoes }}/{{ agenda.disponibilidade }}
                                                    </span>
                                                </span>
                                                <template v-if="!cc">
                                                    <template v-if="lista_colunas.length == 1">
                                                        <span class="ml-2">
                                                            <a href="#" @click.prevent="abrirAgenda(agenda.medico)">
                                                                {{ agenda.medico.st_nome_exibicao }}
                                                            </a>
                                                        </span>
                                                        
                                                        <span class="text-muted" v-if="filtros.especialidade">
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            {{ filtros.especialidade.st_especialidade }}
                                                        </span>
                                                        
                                                        <span class="text-muted" v-else-if="agenda.medico.especialidade">
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            {{ agenda.medico.especialidade.st_especialidade }}
                                                        </span>

                                                        <span v-if="!cc">
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            {{ agenda.marcacoes }}/{{ agenda.disponibilidade }}
                                                        </span>

                                                        <span v-if="agenda.bloqueio" class="text-danger ml-2">
                                                            BLOQUEADO: #{{ agenda.bloqueio.id_bloqueio }} -
                                                            {{ agenda.bloqueio.bloqueio_motivo.st_bloqueio_motivo }}
                                                        </span>
                                                    </template>

                                                    <template v-else>
                                                        <!-- Nenhuma Informação Adicional -->
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <div>
                                                        <span class="badge" :class="agenda.marcacoes ? 'badge-primary' : 'badge-secondary'">
                                                            {{ agenda.qt }}
                                                        </span>
                                                    </div>
                                                </template>
                                                <div v-if="agenda.bloqueio && lista_colunas.length > 1" class="text-danger">
                                                    <div>BLOQUEADO: #{{ agenda.bloqueio.id_bloqueio }}</div>
                                                    <div>{{ agenda.bloqueio.bloqueio_motivo.st_bloqueio_motivo }}</div>
                                                </div>
                                                <div class="progress mb-2" style="height: 2px;" v-if="lista_colunas.length > 1">
                                                    <div class="progress-bar" :class="agenda.marcacoes >= agenda.disponibilidade ? 'bg-success' : ''" role="progressbar" :style="'width: ' + percent(agenda.marcacoes, agenda.disponibilidade) + '%;'"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>

                    <template v-else>

                        <table class="table bg-white small" :class="( lista_colunas.length > 7 ? 'table-responsive' : 'cabecalho-fixo' ) + ( ( ( filtros.tipo == 'C' && visao_hora == 'H' ) || ( lista_colunas.length == 1 ) ) ? ' table-sm' : '' )">
                            <thead>
                                <tr class="table-secondary">
                                    <th :width="lista_colunas.length > 1 ? '12.5%' : ''">{{ ( filtros.tipo == 'C' && visao_hora == 'H' ) ? 'Hora' : 'Sala' }}</th>
                                    <th :width="lista_colunas.length > 1 ? '12.5%' : ''" class="text-nowrap" v-for="(dow, idx) in lista_colunas" :key="idx">
                                        {{ dow.label }}
                                    </th>
                                </tr>
                            </thead>

                            <!-- Visão por Hora -->
                            <template v-if="filtros.tipo == 'C' && visao_hora == 'H'">
                                <template v-for="(local, ilx) in lista_salas">
                                    <tr :key="ilx" v-if="true">
                                        <th :colspan="lista_colunas.length + 1" class="table-dark">
                                            {{ local.centro_custo.unidade_operacao.st_nome }}
                                            <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                            {{ local.centro_custo.st_nome }}
                                            <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                            {{ local.st_local }}
                                        </th>
                                    </tr>
                                    <tr v-for="hora_item in (faixa_hora.ate - faixa_hora.de - 1)" :key="ilx + '.' + hora_item"
                                        :class="'table-' + cor_turno(hora_item + faixa_hora.de)">
                                        <td>
                                            {{ hora_item + faixa_hora.de }}
                                        </td>
                                        <td v-for="(dow, idx) in lista_colunas" :key="idx" class="text-nowrap text-truncate">
                                            <span class="badge badge-secondary" v-if="( calc_ocupacao(local, dow, hora_item + faixa_hora.de) < 0 )">
                                                Não Disponível
                                            </span>
                                            <span class="badge badge-success" v-else-if="!medicos_local(local, dow, hora_item + faixa_hora.de)">
                                                Livre - {{ hora_item + faixa_hora.de }}
                                            </span>
                                            <template v-else>
                                                {{ medicos_local(local, dow, hora_item + faixa_hora.de) }}
                                            </template>
                                        </td>
                                    </tr>

                                    <!-- Ocupação das Salas -->
                                    <tr :key="ilx + '-ocup'" v-if="$store.state.user.id_usuario == 1">
                                        <td>
                                            <a href="#" @click.prevent="view_detalhe_ocup = !view_detalhe_ocup">
                                                <i class="fa-solid fa-eye-slash" v-if="!view_detalhe_ocup"></i>
                                                <i class="fa-solid fa-eye" v-else></i>
                                            </a>
                                            <pre v-if="view_detalhe_ocup">{{ calc_ocupacao(local, null, 'G', true) }}</pre>
                                        </td>
                                        <td v-for="(dow, idx) in lista_colunas" :key="idx" class="text-nowrap text-truncate">
                                            <pre v-if="view_detalhe_ocup">{{ calc_ocupacao(local, dow, 'G', true) }}</pre>
                                        </td>
                                    </tr>
                                </template>
                                
                            </template>
                                
                            <tbody v-else>
                                <tr v-for="(local, ilx) in lista_salas" :key="ilx" :class="lista_colunas.length > 1 || agendas_tabela(local).length ? '' : 'd-print-none'">
                                    <td>
                                        <div v-if="search">
                                            {{ local.search }}
                                        </div>
                                        <template v-else>
                                            <template v-if="lista_colunas.length == 1">
                                                <span class="text-muted">{{ local.centro_custo.unidade_operacao.st_nome }}</span>
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                <span class="text-muted">{{ local.centro_custo.st_nome }}</span>
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                <span>{{ local.st_local }}</span>
                                            </template>

                                            <template v-else>
                                                <div class="text-muted">{{ local.centro_custo.unidade_operacao.st_nome }}</div>
                                                <div class="text-muted">{{ local.centro_custo.st_nome }}</div>
                                                <div>{{ local.st_local }}</div>
                                                <div v-if="filtros.tipo == 'C'">
                                                    <small>
                                                        {{ turno_label(filtros.turno) }}: {{ calc_ocupacao(local, null, filtros.turno ? filtros.turno : 'G') }}%
                                                    </small>
                                                    <div class="progress" style="height: 20px;">
                                                        <div class="progress-bar" :class="cor_calc_ocupacao(local, null, filtros.turno ? filtros.turno : 'G')" role="progressbar" 
                                                            :style="'width: ' + calc_ocupacao(local, null, filtros.turno ? filtros.turno : 'G') + '%;'"></div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </td>
                                    <td v-for="(dow, idx) in lista_colunas" :key="idx">
                                        <div v-if="1 == 0 && lista_colunas[idx].feriado" class="text-muted">
                                            {{ lista_colunas[idx].feriado.st_descricao }}
                                        </div>

                                        <!-- Ocupação da Sala -->
                                        <div v-else-if="filtros.tipo == 'C'">
                                            <div v-if="visao_hora == 'H'">
                                                <div v-for="hora_item in (faixa_hora.ate - faixa_hora.de)" :key="hora_item">
                                                    {{ hora_item }}
                                                </div>
                                            </div>

                                            <template v-else>

                                                <div v-if="( !filtros.turno || filtros.turno == 'M' )">
                                                    <template v-if="calc_ocupacao(local, dow, 'M') < 0">
                                                        <small class="text-nowrap">M: NÃO DISPONÍVEL</small>
                                                        <small class="text-info ml-2">{{ medicos_local (local, dow, 'M') }}</small>
                                                        <div class="progress" style="height: 20px;">
                                                            <div class="progress-bar bg-dark" role="progressbar" style="width: 100%"></div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <small class="text-nowrap">M: {{ calc_ocupacao(local, dow, 'M') + '%' }}</small>
                                                        <small class="text-info ml-2">{{ medicos_local (local, dow, 'M') }}</small>
                                                        <div class="progress" style="height: 20px;">
                                                            <div class="progress-bar" :class="cor_calc_ocupacao(local, dow, 'M')" role="progressbar" :style="'width: ' + calc_ocupacao(local, dow, 'M') + '%'"></div>
                                                        </div>
                                                    </template>
                                                </div>

                                                <div v-if="( !filtros.turno || filtros.turno == 'T' )">
                                                    <template v-if="calc_ocupacao(local, dow, 'T') < 0">
                                                        <small class="text-nowrap">T: NÃO DISPONÍVEL</small>
                                                        <small class="text-info ml-2">{{ medicos_local (local, dow, 'T') }}</small>
                                                        <div class="progress" style="height: 20px;">
                                                            <div class="progress-bar bg-dark" role="progressbar" style="width: 100%"></div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <small class="text-nowrap">T: {{ calc_ocupacao(local, dow, 'T') + '%' }}</small>
                                                        <small class="text-info ml-2">{{ medicos_local (local, dow, 'T') }}</small>
                                                        <div class="progress" style="height: 20px;">
                                                            <div class="progress-bar" :class="cor_calc_ocupacao(local, dow, 'T')" role="progressbar" :style="'width: ' + calc_ocupacao(local, dow, 'T') + '%'"></div>
                                                        </div>
                                                    </template>
                                                </div>

                                                <div v-if="( !filtros.turno || filtros.turno == 'N' )">
                                                    <template v-if="calc_ocupacao(local, dow, 'N') < 0">
                                                        <small class="text-nowrap">N: NÃO DISPONÍVEL</small>
                                                        <small class="text-info ml-2">{{ medicos_local (local, dow, 'N') }}</small>
                                                        <div class="progress" style="height: 20px;">
                                                            <div class="progress-bar bg-dark" role="progressbar" style="width: 100%"></div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <small class="text-nowrap">N: {{ calc_ocupacao(local, dow, 'N') + '%' }}</small>
                                                        <small class="text-info ml-2">{{ medicos_local (local, dow, 'N') }}</small>
                                                        <div class="progress" style="height: 20px;">
                                                            <div class="progress-bar" :class="cor_calc_ocupacao(local, dow, 'N')" role="progressbar" :style="'width: ' + calc_ocupacao(local, dow, 'N') + '%'"></div>
                                                        </div>
                                                    </template>
                                                </div>

                                                <div v-if="( !filtros.turno || filtros.turno == 'G' )">
                                                    <template v-if="calc_ocupacao(local, dow, 'G') < 0">
                                                        <small>Geral: </small>
                                                        <div class="progress" style="height: 20px;">
                                                            <div class="progress-bar bg-dark" role="progressbar" style="width: 100%"></div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <small>Geral: {{ calc_ocupacao(local, dow, 'G') + '%' }}</small>
                                                        <div class="progress" style="height: 20px;">
                                                            <div class="progress-bar" :class="cor_calc_ocupacao(local, dow, 'G')" role="progressbar" :style="'width: ' + calc_ocupacao(local, dow, 'G') + '%'"></div>
                                                        </div>
                                                    </template>
                                                </div>

                                            </template>
                                        </div>
                                        
                                        <!-- Ocupação dos Médicos -->
                                        <div v-else>
                                            <!-- agendas_do_dia(local.agendas, dow.dia) -->
                                            <div v-for="(agenda, iax) in agendas_tabela(local, dow)" :key="ilx + '-' + iax">
                                                <span class="text-nowrap" :class="( agenda.bloqueio ? 'text-muted' : '' ) + ( lista_colunas.length == 1 ? '' : 'div' )">
                                                    {{ agenda.search }}
                                                    <span class="badge" v-if="!cc && lista_colunas.length > 1"
                                                        :class="agenda.marcacoes >= agenda.disponibilidade ? 'badge-success' : ( agenda.marcacoes ? 'badge-primary' : 'badge-secondary' )">
                                                        {{ agenda.marcacoes }}/{{ agenda.disponibilidade }}
                                                    </span>
                                                </span>
                                                <template v-if="!cc">
                                                    <template v-if="lista_colunas.length == 1">
                                                        <span class="ml-2">
                                                            <a href="#" @click.prevent="abrirAgenda(agenda.medico)">
                                                                {{ agenda.medico.st_nome_exibicao }}
                                                            </a>
                                                        </span>
                                                        
                                                        <span class="text-muted" v-if="filtros.especialidade">
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            {{ filtros.especialidade.st_especialidade }}
                                                        </span>
                                                        
                                                        <span class="text-muted" v-else-if="agenda.medico.especialidade">
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            {{ agenda.medico.especialidade.st_especialidade }}
                                                        </span>

                                                        <span v-if="!cc">
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            {{ agenda.marcacoes }}/{{ agenda.disponibilidade }}
                                                        </span>

                                                        <span v-if="agenda.bloqueio" class="text-danger ml-2">
                                                            BLOQUEADO: {{ agenda.bloqueio.bloqueio_motivo.st_bloqueio_motivo }}
                                                        </span>
                                                    </template>

                                                    <template v-else>
                                                        <div>
                                                            <a href="#" @click.prevent="abrirAgenda(agenda.medico)">
                                                                {{ agenda.medico.st_nome_exibicao }}
                                                            </a>
                                                        </div>
                                                        <div class="text-muted" v-if="filtros.especialidade">
                                                            {{ filtros.especialidade.st_especialidade }}
                                                        </div>
                                                        <div class="text-muted" v-else-if="agenda.medico.especialidade">
                                                            {{ agenda.medico.especialidade.st_especialidade }}
                                                        </div>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <div>
                                                        <span class="badge" :class="agenda.marcacoes ? 'badge-primary' : 'badge-secondary'">
                                                            {{ agenda.qt }}
                                                        </span>
                                                    </div>
                                                </template>
                                                <div v-if="agenda.bloqueio && lista_colunas.length > 1" class="text-danger">
                                                    <div>BLOQUEADO: #{{ agenda.bloqueio.id_bloqueio }}</div>
                                                    <div>{{ agenda.bloqueio.bloqueio_motivo.st_bloqueio_motivo }}</div>
                                                </div>
                                                <div class="progress mb-2" style="height: 2px;" v-if="lista_colunas.length > 1">
                                                    <div class="progress-bar" :class="agenda.marcacoes >= agenda.disponibilidade ? 'bg-success' : ''" role="progressbar" :style="'width: ' + percent(agenda.marcacoes, agenda.disponibilidade) + '%;'"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <!-- Ocupação Global -->
                            <tbody v-if="!cc && !simplificado && !(filtros.tipo == 'C' && visao_hora == 'H')" :class="lista_colunas.length == 1 ? 'd-print-none' : ''">
                                <tr class="table-secondary">
                                    <th width="12.5%">Ocupação</th>
                                    <th width="12.5%" v-for="(dow, idx) in lista_colunas" :key="idx">
                                        {{ dow.label }}
                                    </th>
                                </tr>
                                <tr>
                                    <td>
                                        <div v-if="!filtros.turno || filtros.turno == 'M'">
                                            <small class="text-nowrap">
                                                Manhã: {{ calc_ocupacao(null, null, 'M') }}%
                                            </small>
                                            <div class="progress" style="height: 20px;">
                                                <div class="progress-bar" :class="calc_ocupacao(null, null, 'M') >= 100 ? 'bg-success' : ''" role="progressbar" :style="'width: ' + calc_ocupacao(null, null, 'M') + '%;'"></div>
                                            </div>
                                        </div>
                                        <div v-if="!filtros.turno || filtros.turno == 'T'">
                                            <small>
                                                Tarde: {{ calc_ocupacao(null, null, 'T') }}%
                                            </small>
                                            <div class="progress" style="height: 20px;">
                                                <div class="progress-bar" :class="calc_ocupacao(null, null, 'T') >= 100 ? 'bg-success' : ''" role="progressbar" :style="'width: ' + calc_ocupacao(null, null, 'T') + '%;'"></div>
                                            </div>
                                        </div>
                                        <div v-if="!filtros.turno || filtros.turno == 'N'">
                                            <small>
                                                Noite: {{ calc_ocupacao(null, null, 'N') }}%
                                            </small>
                                            <div class="progress" style="height: 20px;">
                                                <div class="progress-bar" :class="calc_ocupacao(null, null, 'N') >= 100 ? 'bg-success' : ''" role="progressbar" :style="'width: ' + calc_ocupacao(null, null, 'N') + '%;'"></div>
                                            </div>
                                        </div>
                                        <div v-if="!filtros.turno || filtros.turno == 'G'">
                                            <small>
                                                <a href="#" @click.prevent="validar_ocupacao(null, null, 'G')" class="card-link">
                                                    Geral: {{ calc_ocupacao(null, null, 'G') }}%
                                                </a>
                                            </small>
                                            <div class="progress" style="height: 20px;">
                                                <div class="progress-bar" :class="calc_ocupacao(null, null, 'G') >= 100 ? 'bg-success' : ''" role="progressbar" :style="'width: ' + calc_ocupacao(null, null, 'G') + '%;'"></div>
                                            </div>
                                        </div>
                                    </td>
                                    <td v-for="(dow, idx) in lista_colunas" :key="idx">
                                        <div v-if="!filtros.turno || filtros.turno == 'M'">
                                            <small class="text-nowrap">
                                                Manhã: {{ calc_ocupacao(null, dow, 'M') }}%
                                            </small>
                                            <div class="progress" style="height: 20px;">
                                                <div class="progress-bar" :class="calc_ocupacao(null, dow, 'M') >= 100 ? 'bg-success' : ''" role="progressbar" :style="'width: ' + calc_ocupacao(null, dow, 'M') + '%;'"></div>
                                            </div>
                                        </div>
                                        <div v-if="!filtros.turno || filtros.turno == 'T'">
                                            <small>
                                                Tarde: {{ calc_ocupacao(null, dow, 'T') }}%
                                            </small>
                                            <div class="progress" style="height: 20px;">
                                                <div class="progress-bar" :class="calc_ocupacao(null, dow, 'T') >= 100 ? 'bg-success' : ''" role="progressbar" :style="'width: ' + calc_ocupacao(null, dow, 'T') + '%;'"></div>
                                            </div>
                                        </div>
                                        <div v-if="!filtros.turno || filtros.turno == 'N'">
                                            <small>
                                                Noite: {{ calc_ocupacao(null, dow, 'N') }}%
                                            </small>
                                            <div class="progress" style="height: 20px;">
                                                <div class="progress-bar" :class="calc_ocupacao(null, dow, 'N') >= 100 ? 'bg-success' : ''" role="progressbar" :style="'width: ' + calc_ocupacao(null, dow, 'N') + '%;'"></div>
                                            </div>
                                        </div>
                                        <div v-if="!filtros.turno || filtros.turno == 'G'">
                                            <small>
                                                Geral: {{ calc_ocupacao(null, dow, 'G') }}%
                                            </small>
                                            <div class="progress" style="height: 20px;">
                                                <div class="progress-bar" :class="calc_ocupacao(null, dow, 'G') >= 100 ? 'bg-success' : ''" role="progressbar" :style="'width: ' + calc_ocupacao(null, dow, 'G') + '%;'"></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </template>

                </template>

            </div>

            <div class="row" v-if="!cc && !simplificado && filtros.tipo != 'P'">
                <div class="col col-12">
                    <div class="card carde">
                        <div class="card-header">
                            Ocupação
                        </div>
                        <div class="card-body">
                            <Chart 
                                type="line" 
                                :data="grafico_ocupacao ()" 
                                :options="{ 
                                    legend: { display: true },
                                    scales: {
                                        yAxes: [{
                                            ticks: {
                                                callback: function(value, index, values) {
                                                    return value + '%';
                                                }
                                            }
                                        }],
                                    }
                                }" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="false && filtros.tipo != 'P'">
                <div class="col col-12">
                    <div class="card carde">
                        <div class="card-header">
                            Audiograma
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <audiograma :dados="audiograma1" />
                            </div>
                            <div class="row">
                                <audiograma :dados="audiograma2" :altura="400" :largura="600" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>

        <az-empty-state 
                v-else
                :icon="firstLoad ? '' : 'fas fa-sync-alt'" 
                :msg="firstLoad ? 'Nenhuma agenda encontrada.' : 'Clique no ícone para atualizar a busca.'"
                :action="firstLoad ? '' : 'Buscar'"
                :method="load"></az-empty-state>

        <pre class="alert alert-info" v-if="false">{{ filtros }}</pre>
    </div>
</template>

<script>
import _ from 'lodash';
import * as moment from 'moment';
import SubMenuCallCenter from "./SubMenuCallCenter.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import Audiograma from '../../shared/Audiograma.vue';

export default {
    data() { 
        return { 
            dados: null, 
            agendas_por_local: null, 
            agendas_por_dia: null, 
            agendas_por_dw: null, 
            agendas_por_chave: null, 
            agendas_por_chave_md: null, 
            agendas_por_chave_dw: null, 
            agendas_por_medico: null, 
            filtros: { 
                referencia: this.$util.hoje(),
                inicio: this.$util.hoje(), 
                fim: this.$util.hoje(), // this.recepcao ? this.hoje() : moment().add(6, "days").format('YYYY-MM-DD'),
                especialidade: "", 
                id_procedimento: "", 
                medico: "",
                search: "", 
                unidade_operacao: "", 
                turno: "", 
                tipo: "D",
                searched_uo: "",
                periodo: "s", 
                id_classe_procedimento: "", 
                id_local: "", 
            },
            search: "", 
            medicos: [],
            montando: true, 
            canceltoken: null, 
            semana: "", 
            firstLoad: false, 

            lista_medicos_agendas: [], 
            lista_medicos_numeros: [], 

            visao: "M", 
            visao_hora: "T", 

            exibir_profs: true, 
            view_detalhe_ocup: false, 

            audiograma1: [
                {
                    ouvido: "direito", 
                    tipo: "aerea",
                    valores: [
                        {
                            frequencia: 125,
                            mascara: false,
                            valor: 5,
                            ausente: false,
                        },
                        {
                            frequencia: 250,
                            mascara: false,
                            valor: 10,
                            ausente: false,
                        },
                        {
                            frequencia: 500,
                            mascara: false,
                            valor: 10,
                            ausente: false,
                        },
                        {
                            frequencia: 1000,
                            mascara: false,
                            valor: 15,
                            ausente: false,
                        },
                        {
                            frequencia: 2000,
                            mascara: false,
                            valor: 10,
                            ausente: false,
                        },
                        {
                            frequencia: 4000,
                            mascara: false,
                            valor: 10,
                            ausente: false,
                        },
                        {
                            frequencia: 8000,
                            mascara: false,
                            valor: 15,
                            ausente: false,
                        },
                    ]
                }
            ],
            audiograma2: [
                {
                    ouvido: "esquerdo", 
                    tipo: "aerea",
                    valores: [
                        {
                            frequencia: 125,
                            mascara: false,
                            valor: 10,
                            ausente: false,
                        },
                        {
                            frequencia: 250,
                            mascara: false,
                            valor: 10,
                            ausente: false,
                        },
                        {
                            frequencia: 500,
                            mascara: false,
                            valor: 10,
                            ausente: false,
                        },
                        {
                            frequencia: 1000,
                            mascara: false,
                            valor: 5,
                            ausente: false,
                        },
                        {
                            frequencia: 2000,
                            mascara: false,
                            valor: 10,
                            ausente: false,
                        },
                        {
                            frequencia: 4000,
                            mascara: false,
                            valor: 10,
                            ausente: false,
                        },
                        {
                            frequencia: 8000,
                            mascara: false,
                            valor: 5,
                            ausente: false,
                        },
                    ]
                }
            ]
        }
    },

    components: { 
        SubMenuCallCenter,
        AzEmptyState,
        AzInput,
        PrintExport, 
        CabecalhoGenerico, 
        AzPeriodo, 
        Audiograma,
    },

    props: ['simplificado'],

    computed: { 
        dadosFormatados: function () { 
            if ( this.filtros.tipo != 'P' ) { 
                return null;
            }

            return this.exibir_lista_profissionais.map(item => { 
                return { 
                    id: item.id_medico, 
                    nome: item.st_nome_exibicao, 
                    disponibilidade: item.disp, 
                    marcacoes_slots: item.marc, 
                    marcacoes_qtd: item.marc_qtd, 
                    bloqueio: item.bloq, 
                    atendimentos_slots: item.atend, 
                    atendimentos_qtd: item.atend_qtd, 
                    faltas_slots: item.faltas, 
                    faltas_qtd: item.faltas_qtd,
                    extras: item.extras, 
                    perc_atend: item.perc_atend ? this.$util.formatNumber(item.perc_atend, 1) : '', 
                    perc_faltas: item.perc_faltas ? this.$util.formatNumber(item.perc_faltas, 1) : '', 
                    perc_marc: item.perc_marc ? this.$util.formatNumber(item.perc_marc, 1) : '', 
                    perc_bloq: item.perc_bloq ? this.$util.formatNumber(item.perc_bloq, 1) : '', 
                };
            });
        },

        faixa_hora: function () { 
            if ( this.filtros.turno && this.filtros.turno != 'G' ) { 
                return { 
                    de: parseInt(this.dados.turnos[this.filtros.turno].de), 
                    ate: parseInt(this.dados.turnos[this.filtros.turno].ate)
                };    
            }

            return { 
                de: this.dados.turnos['M'].de, 
                ate: this.dados.turnos['N'].ate
            };
        },

        lista_colunas: function () { 
            if ( this.visao == 'M' || this.filtros.tipo != 'C' || this.dados.periodo.semana.length <= 7 ) 
                return this.dados.periodo.semana;

            let lista = _.cloneDeep(this.dados.periodo.semana);

            return _.orderBy(
                _.map(
                    _.uniqBy(lista, 'dia'),
                    item => { 
                        item.label = item.label.slice(-3);
                        return item;
                    }
                ),
                'dia'
            );
        },

        lista_unidades: function () { 
            return _.orderBy(
                this.$store.state.unidade.unidade_operacaos.filter(item => !item.fl_unidade_adm),
                'st_nome'
            );
        },

        recepcao: function () { 
            return this.$route.name == 'rmapasala';
        },

        cc: function () { 
            return this.$route.path.substr(0,17) == '/centro-cirurgico'
                || this.$route.path.substr(0,8) == '/infusao';
        },

        infusao: function () { 
            return this.$route.path.substr(0,8) == '/infusao';
        },

        exibir_lista_profissionais: function () { 
            if ( !this.lista_medicos_numeros )
                return [];

            if ( !this.search )
                return this.lista_medicos_numeros;

            let reg = this.$util.getregex(this.search);

            return this.lista_medicos_numeros.filter(item => reg.test(JSON.stringify(item)));
        },

        exibir_total_profissionais: function () { 
            return this.exibir_lista_profissionais.reduce((total, carry) => { 
                    total.disp += carry.disp;
                    total.marc +=  carry.marc;
                    total.marc_qtd +=  carry.marc_qtd;
                    total.bloq += carry.bloq;
                    total.atend +=  carry.atend;
                    total.atend_qtd +=  carry.atend_qtd;
                    total.faltas +=  carry.faltas;
                    total.faltas_qtd +=  carry.faltas_qtd;
                    total.extras += carry.extras;

                    if ( total.disp ) { 
                        if ( total.marc ) { 
                            total.perc_atend = Math.round( ( total.atend / ( total.marc + total.extras ) ) * 1000 ) / 10;
                        }

                        if ( total.faltas ) {
                            total.perc_faltas = Math.round( ( total.faltas / ( total.atend + total.faltas ) ) * 1000 ) / 10;
                        }

                        total.perc_marc = Math.round( ( total.marc / total.disp ) * 1000 ) / 10;
                        total.perc_bloq = Math.round( ( total.bloq / total.disp ) * 1000 ) / 10;
                    }

                    return total;
                }, {
                    disp: 0,
                    marc: 0,
                    marc_qtd: 0,
                    atend_qtd: 0, 
                    extras: 0, 
                    bloq: 0, 
                    faltas: 0, 
                    faltas_qtd: 0,
                    atend: 0,
                    perc_atend: 0,
                    perc_faltas: 0,
                    perc_marc: 0,
                    perc_bloq: 0, 
                });
        },

        lista_medicos: function () { 
            if ( !this.medicos )
                return [];

            if ( !this.search )
                return this.medicos;

            let reg = this.$util.getregex(this.search);

            return this.medicos.filter(item => reg.test(JSON.stringify(item)));
            /*
                .filter(
                    item => item.medico_especialidade.find(
                        esp => esp.id_especialidade == this.filtros.especialidade.id_especialidade
                    )
                );
            */
        },

        lista_medicos_relatorio: function () { 
            return this.lista_medicos.filter(item => this.lista_medicos_agendas[item.id_pessoa]);
        },

        filtrado: function () { 
            return true;
            //return this.filtros.especialidade || this.filtros.medico;
        },

        lista_salas: function () { 
            if ( !this.dados )
                return [];

            if ( this.search ) { 
                /*
                const reg = this.$util.getregex(this.search);

                return this.dados.salas.filter(item => reg.test(JSON.stringify(item)));
                */

                let teste = _.uniqBy(
                    this.agendas_tabela().map(item => item.local),
                    'id_local'
                );

                return teste;
            }

            return this.dados.salas;

            /*

            if ( !this.filtros.unidade_operacao )
                return this.dados.salas;
            
            return this.dados.salas.filter(item => item.centro_custo.id_unidade_operacao == this.filtros.unidade_operacao);

            */
        },

        lista_agendas_por_medico: function () { 
            return _.groupBy(this.dados.agendas, 'id_medico');
        },

        lista_agendas_por_local: function () { 
            return _.groupBy(this.dados.agendas, 'id_local');
        },

    },

    methods: { 
        validar_ocupacao (local, dia, turno) { 
            this.calc_ocupacao(local, dia, turno, true);
        },

        selecionar_medico_dia (med, dow) { 
            this.$emit('selecionado', { id_medico: med.id, data: dow.data });
        },

        cor_turno(hora) { 
            switch ( this.qual_turno(hora) ) { 
                case 'M': return 'primary';
                case 'T': return 'warning';
                case 'N': return 'info';
            }

            return 'light';
        },

        qual_turno(hora) {
            // let retorno = '';

            return _.findKey(
                this.dados.turnos, 
                item => hora >= item.de && hora < item.ate
            );
        },

        pesquisar (texto) { 
            this.search = ( this.search == '"' + texto + '"' ) ? '' : '"' + texto + '"';
        },

        numeros_medico(medico = null, por_local = false) { 
            let numeros; 

            if ( medico ) { 
                if ( por_local ) { 
                    numeros = this.lista_agendas_por_local[medico.id_local];                    
                } else {
                    numeros = this.lista_agendas_por_medico[medico.id_pessoa];
                }
            } else { 
                numeros = this.dados.agendas;
            }

            if ( !numeros )
                return {};

            if ( !medico ) { 

                numeros = numeros.filter(item => { 
                        if ( !medico ) { 
                            return this.lista_medicos_relatorio.find(ml => item.id_medico == ml.id_pessoa);
                        } else { 
                            return item.id_medico == medico.id_pessoa;
                        }
                    });

            }

            numeros = numeros.reduce((total, carry) => { 
                    total.disp += carry.disponibilidade;
                    total.marc +=  carry.marcacoes;
                    total.marc_qtd +=  carry.marcacoes_qtd;
                    total.extras +=  carry.extras;
                    total.bloq += carry.bloqueio 
                        ? ( ( carry.disponibilidade - ( carry.qt_bloq ? carry.qt_bloq : 0 ) ) >= carry.atendidos 
                            ? ( carry.qt_bloq > 0 && carry.qt_bloq < carry.disponibilidade ) ? carry.qt_bloq : ( carry.disponibilidade - carry.atendidos ) 
                            : 0 ) 
                        : 0;
                    total.atend +=  carry.atendidos;
                    total.atend_qtd +=  carry.atendidos_qtd;
                    total.faltas +=  carry.faltas;
                    total.faltas_qtd +=  carry.faltas_qtd;
                    
                    return total;
                }, {
                    disp: 0,
                    marc: 0, 
                    marc_qtd: 0,
                    extras: 0, 
                    bloq: 0, 
                    faltas: 0, 
                    faltas_qtd: 0, 
                    atend: 0,
                    atend_qtd: 0,
                });

            if ( numeros.disp ) { 
                if ( numeros.marc ) { 
                    numeros.perc_atend = Math.round( ( numeros.atend / ( numeros.marc + numeros.extras ) ) * 1000 ) / 10;
                }

                if ( numeros.faltas ) {
                    numeros.perc_faltas = Math.round( ( numeros.faltas / ( numeros.atend + numeros.faltas ) ) * 1000 ) / 10;
                }

                numeros.perc_marc = Math.round( ( numeros.marc / numeros.disp ) * 1000 ) / 10;
                numeros.perc_bloq = Math.round( ( numeros.bloq / numeros.disp ) * 1000 ) / 10;
            }

            return numeros;
        },
        
        cor_calc_ocupacao(local, dia, turno) { 
            const calc = this.calc_ocupacao(local, dia, turno);

            if ( calc < 0 ) {
                return 'bg-dark'; 
            } else if ( calc <= 65 ) { 
                return 'bg-warning';
            } else if ( calc >= 100 ) {
                return 'bg-success';
            }

            return '';
        },

        medicos_local(local, dia, turno) { 
            let agendas = this.agendas_tabela(local, dia);

            let de;
            let ate;

            if ( !isNaN(turno) ) { 
                de = turno;
                ate = turno;
            } else { 
                de  = ( turno == 'G' ? this.dados.turnos['M'].de : this.dados.turnos[turno].de );
                ate = ( turno == 'G' ? this.dados.turnos['N'].ate : this.dados.turnos[turno].ate );
            }

            let lista = agendas.filter(agenda => !agenda.bloqueio && !agenda.nd)
                .filter(agenda => agenda.hr_inicio && agenda.hr_termino 
                    && parseInt(agenda.hr_inicio.substr(0,2)) <= ate 
                    && ( 
                        ( parseInt(agenda.hr_termino.substr(0,2)) > de && !parseInt(agenda.hr_termino.substr(3,4)) )
                        || ( parseInt(agenda.hr_termino.substr(0,2)) >= de && parseInt(agenda.hr_termino.substr(3,4)) )
                    )
                );

            let add_nome = ( ( this.visao == 'S' && this.filtros.tipo == 'C' ) ? _.uniqBy(lista, 'ref').length + ':' : '' ); 
                    
            lista = _.uniqBy(lista,
                    'medico.st_nome_exibicao'
                )
                .map(item => add_nome + item.medico.st_nome_exibicao)
                .join(', ');

            return lista.length > 15 ? lista.substr(0,15) + '...' : lista;
        },

        calc_ocupacao(local, dia, turno, teste = false) { 
            let agendas = this.agendas_tabela(local, dia);

            let de;
            let ate;

            if ( !isNaN(turno) ) { 
                de = turno;
                ate = turno + 1;
            } else { 
                de  = ( turno == 'G' ? this.dados.turnos['M'].de : this.dados.turnos[turno].de );
                ate = ( turno == 'G' ? this.dados.turnos['N'].ate : this.dados.turnos[turno].ate );
            }

            if ( local 
                && dia 
                && agendas.find(agenda => agenda.nd 
                        && agenda.horas.find(hora => parseInt(hora.substr(0,2)) >= parseInt(de) 
                                                && parseInt(hora.substr(0,2)) < parseInt(ate))) 
                && !agendas.find(agenda => !agenda.nd) 
            ) { 
                return -1;
            }

            let horas = agendas
                .filter(agenda => !agenda.bloqueio && !agenda.nd)
                .reduce((total, carry) => _.union(total, carry.horas), []);

            // console.log('aqui', dia ? dia.dia : 'NT', local);

            if ( teste && dia && local && local.disp && _.get(local.disp, dia.dia) ) { 

                if ( local.disp[dia.dia].de && local.disp[dia.dia].de > de ) { 
                    de = parseInt(local.disp[dia.dia].de.slice(0,2));
                }

                if ( local.disp[dia.dia].ate && local.disp[dia.dia].ate < ate ) { 
                    ate = parseInt(local.disp[dia.dia].ate.slice(0,2));
                }

                console.log('disp', 'DE-' + de, 'ATE-' + ate, 'D' + dia.dia, local.disp);
            }

            let blocos = ( local ? 1 : this.lista_salas.length ) * ( dia ? 1 : this.dados.periodo.semana.length );
            let total = ( ate - de ) * blocos;

            if ( this.visao == 'S' && this.filtros.tipo == 'C' && dia ) { 
                total = total * this.dados.periodo.semana.filter(item => item.dia == dia.dia).length;
            }

            let ocupacao = horas.filter(item => 
                parseInt(item.substr(0,2)) >= parseInt(de) 
                && parseInt(item.substr(0,2)) < parseInt(ate)
            ).length;

            if ( teste ) { 
                /*
                console.log('calc_ocup', local, dia, turno, ocupacao, total);
                console.log('faixa', de, ate);
                console.log('horas', horas);
                console.log('agendas', agendas);
                console.log('ocup', total ? Math.round ( ( ocupacao / total ) * 100 ) : 0);
                */
                
                return { 
                    percent: total ? Math.round ( ( ocupacao / total ) * 100 ) : 0, 
                    numerador: ocupacao,
                    denominador: total, 
                    faixa: { 
                        de: de, 
                        ate: ate
                    },
                };
            }

            return total ? Math.round ( ( ocupacao / total ) * 100 ) : 0;
        },

        agendas_tabela(local = null, dia = null, medico = null) { 
            let base = null;

            if ( this.visao == 'S' && this.filtros.tipo == 'C' ) { 

                if ( dia && local ) { 
                    base = this.agendas_por_chave_dw[dia.dia + '-' + local.id_local];
                } else if ( dia ) { 
                    base = this.agendas_por_dw[dia.dia];
                } else if ( local ) { 
                    base = this.agendas_por_local[local.id_local];
                } else { 
                    base = this.dados.agendas;
                }

            } else { 

                if ( dia && local ) { 
                    base = this.agendas_por_chave[dia.data + '-' + local.id_local];
                } else if ( dia && medico ) { 
                    base = this.agendas_por_chave_md[dia.data + '-' + medico.id];
                } else if ( dia ) { 
                    base = this.agendas_por_dia[dia.data];
                } else if ( local ) { 
                    base = this.agendas_por_local[local.id_local];
                } else { 
                    base = this.dados.agendas;
                }

            }

            if ( !base ) {
                base = [];
            }

            // .filter(item => !this.filtros.medico || item.id_medico == this.filtros.medico)
            // .filter(item => !this.filtros.especialidade 
                    // || item.medico.medico_especialidade.findIndex(esp => esp.id_especialidade == this.filtros.especialidade.id_especialidade) >= 0)
            // .filter(item => !this.filtros.unidade_operacao || item.local.id_unidade_operacao == this.filtros.unidade_operacao)

            if ( !this.search && ( !this.filtros.turno || this.filtros.turno == 'G' ) ) { 

                return base;
                
            } else { 

                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(' ','.*');
                let match = parts;
                let reg = new RegExp(match, 'i');

                let turno = this.filtros.turno;
                let de  = ( ( !turno || turno == 'G' ) ? this.dados.turnos['M'].de : this.dados.turnos[turno].de );
                let ate = ( ( !turno || turno == 'G' ) ? this.dados.turnos['N'].ate : this.dados.turnos[turno].ate );

                // .filter(item => (!dia || item.ref == dia.data ) && (!local || item.id_local == local.id_local))
                
                return base.filter(item => ( !this.filtros.turno || this.filtros.turno == 'G' 
                            || ( parseInt(item.hr_inicio.substr(0,2)) < parseInt(ate) && parseInt(item.hr_termino.substr(0,2)) > parseInt(de) ) ) 
                        && ( !this.search || reg.test(JSON.stringify(item))) 
                    );

            }
        },
        
        grafico_medico() { 

            let lista = _.groupBy(
                _.flatMap(this.dados.salas, sala => sala.agendas),
                item => item.medico.st_nome_exibicao
            );

            let valores = _.map(
                lista,
                (items, chave) => { 
                    return { 
                        label: chave,
                        value: _.sumBy(items, 'duracao'),
                    };
                }
            );
        
            return valores;

        },
        grafico_ocupacao() { 

            let valores = _.map(
                this.dados.periodo.semana,
                (dow) => { 
                    return { 
                        label: dow.label,
                        manha: this.calc_ocupacao(null, dow, 'M'), 
                        tarde: this.calc_ocupacao(null, dow, 'T'),
                        noite: this.calc_ocupacao(null, dow, 'N'),
                        geral: this.calc_ocupacao(null, dow, 'G'),
                    }
                }
            );

            let dataset = [];

            if ( !this.filtros.turno || this.filtros.turno == 'M' ) { 
                dataset.push({
                        label: 'Manhã',
                        lineTension: 0,
                        backgroundColor: 'rgba(0,255,0,0.1)',
                        borderColor: '#33CC11',
                        fill: true, 
                        data: _.map(valores, (item) => { 
                            return item.manha;
                        })
                    });
            }

            if ( !this.filtros.turno || this.filtros.turno == 'T' ) { 
                dataset.push({
                        label: 'Tarde',
                        lineTension: 0,
                        backgroundColor: 'rgba(255,0,0,0.1)',
                        borderColor: '#CC0000',
                        fill: true, 
                        data: _.map(valores, (item) => { 
                            return item.tarde;
                        })
                    });
            }

            if ( !this.filtros.turno || this.filtros.turno == 'N' ) { 
                dataset.push({
                        label: 'Noite',
                        lineTension: 0,
                        backgroundColor: 'rgba(0,0,255,0.1)',
                        borderColor: '#0000CC',
                        fill: true, 
                        data: _.map(valores, (item) => { 
                            return item.noite;
                        })
                    });
            }

            if ( !this.filtros.turno || this.filtros.turno == 'G' ) { 
                dataset.push({
                        label: 'Geral',
                        lineTension: 0,
                        backgroundColor: 'rgba(255,0,255,0.1)',
                        borderColor: '#CC00CC',
                        fill: true, 
                        data: _.map(valores, (item) => { 
                            return item.geral;
                        })
                    });
            }

            let grafico = {
                labels: _.map(valores, (item) => { 
                    return item.label;
                }),
                datasets: dataset,
            };
                    
            return grafico;

        },
        percent (num, dem) { 
            if ( !dem )
                return 0;

            if ( num > dem )
                return 100;

            return Math.round ( ( num / dem ) * 100 );
        },

        abrirAgenda (medico) { 
            
            this.$router.push({ 
                name: 'c-agendas', 
                params: { 
                    id_medico: medico.id_pessoa, 
                }
            });

        },

        horas(agendas, de, ate) { 
            let ocupado = 0;

            for (let index = de; index < ate; index++) {
                if ( agendas.findIndex(agenda => agenda.hr_inicio.substr(0,2) <= index && agenda.hr_termino.substr(0,2) > index) >= 0)
                    ocupado ++;
            }

            return ocupado;
        },

        turno_label (turno) { 
            switch (turno) {
                case 'M': return 'Manhã';
                case 'T': return 'Tarde';
                case 'N': return 'Noite';
                default: return 'Geral';
            }
        },

        dia_da_semana (dia) { 
            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sáb';
            }
        },

        agendas_do_dia(agendas, dia) { 
            return agendas.filter(item => item.in_dia_semana == dia && item.valida);

                /*
                .filter(item => !this.filtros.especialidade 
                    || item.medico.medico_especialidade.findIndex(esp => esp.id_especialidade == this.filtros.especialidade.id_especialidade) >= 0)
                .filter(item => !this.filtros.medico || item.id_medico == this.filtros.medico);
                */
        },

        refresh_unidade() { 
            if ( this.montando ) 
                return;

            this.$util.setCookie('mapa-unidade', this.filtros.unidade_operacao, 365);
            
            if ( this.searched_uo ) { 
                this.$nextTick(() => { 
                    // this.load();
                });
            }
        },

        load(origem) { 

            if ( origem == 'from' ) { 

                this.filtros.fim = this.recepcao
                    ? this.filtros.inicio
                    : moment(this.filtros.inicio).add(6, "days").format('YYYY-MM-DD'); 

                return;

            }

            if ( this.montando ) 
                return;

            if ( !this.filtros.inicio || !this.filtros.fim )
                return;

            this.firstLoad = true;

            let uo = this.filtros.unidade_operacao;

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.$util.load(this, { 
                service: 'agendas',
                func: 'mapa_de_sala',
                redir_api: true, 
                canceltoken: this.canceltoken.token,
                parms: { 
                    ...this.filtros, 
                    cc: this.cc, 
                    infusao: this.infusao, 
                },
                loadTo: res => { 
                    this.searched_uo = uo;
                    this.agendas_por_local = _.groupBy(res.agendas, 'id_local');
                    this.agendas_por_dia = _.groupBy(res.agendas, 'ref');
                    this.agendas_por_dw = _.groupBy(res.agendas, 'dw');
                    this.agendas_por_chave = _.groupBy(res.agendas, 'chave');
                    this.agendas_por_chave_md = _.groupBy(res.agendas, 'chave_md');
                    this.agendas_por_chave_dw = _.groupBy(res.agendas, 'chave_dw');
                    this.dados = res;

                    if ( res.coldom ) { 

                        this.lista_medicos_numeros = _.orderBy(
                            _.map(
                                _.groupBy(this.dados.agendas, 'id_local'),
                                (agendas, medico) => { 

                                    console.log('agendas', medico, agendas);

                                    return { 
                                        id_medico: medico, 
                                        st_nome_exibicao: agendas[0].local.search,
                                        medico_especialidade: [], 
                                        ...this.numeros_medico({id_local: medico}, true)
                                    };
                                }
                            ),
                            'st_nome_exibicao'
                        );

                        
                        console.log('lista: ', this.lista_medicos_numeros);

                    } else { 

                        this.lista_medicos_numeros = _.orderBy(
                            _.map(
                                _.groupBy(this.dados.agendas, 'id_medico'),
                                (agendas, medico) => { 
                                    let espec = this.medicos.find(md => md.id_pessoa == medico);
                                    return { 
                                        id_medico: medico, 
                                        ...agendas[0].medico,
                                        medico_especialidade: espec ? espec.medico_especialidade : [], 
                                        ...this.numeros_medico({id_pessoa: medico})
                                    };
                                }
                            ),
                            'st_nome_exibicao'
                        );

                    }

                }
            });
        }
    },

    beforeMount() { 

        this.filtros.fim = this.recepcao
            ? this.filtros.inicio
            : moment(this.filtros.inicio).add(6, "days").format('YYYY-MM-DD'); 
  
    },

    mounted() { 
        this.filtros.unidade_operacao = this.$util.getCookie('mapa-unidade');

        if ( !this.simplificado ) { 

            this.$util.loadItem(this, { 
                service: 'medicos',
                func:'index',
                parms: { 
                    ativos: true,
                },
            })
            .then(res => { 
                this.medicos = res;
            });

        }

        if ( this.$route.meta.consultorio ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Consultório", path: "/consultorio" },
                { name: "Mapa de Agendas", path: "/consultorio/mapa" }
            ]);
        } else if ( this.recepcao ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Recepção", path: "/recepcao" },
                { name: "Mapa de Sala", path: "/recepcao/mapasala" }
            ]);
        } else if ( this.infusao ) { 
            this.$store.commit(
                'setBreadcrumb', 
                [
                    { name: "Infusão", path: "/infusao/planejamento" },
                    { name: "Poltronas", path: "/infusao/mapasala"}
                ]
            );
        } else if ( this.cc ) { 
            this.$store.commit(
                'setBreadcrumb', 
                [
                    { name: "Centro Cirúrgico", path: "/centro-cirurgico/marcacao" },
                    { name: "Mapa de Sala", path: "/centro-cirurgico/mapasala"}
                ]
            );
        }

        this.$nextTick(() => { 
            this.montando = false;
            // this.load();
        });
    }
}
</script>

<style scoped>
.progress-bar { 
    transition: none;
}
</style>
